import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { storesAccessRoles } from './access';

export const storesRoutes: RouteObject[] = [
  {
    path: 'stores',
    async lazy() {
      const { StoresPage } = await import('./pages/StoresPage');
      return { Component: StoresPage };
    },
    handle: defineHandle({
      roles: [...storesAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.stores',
    }),
  },
  {
    path: 'stores/:id',
    async lazy() {
      const { StoreDetailPage } = await import('./pages/StoreDetailPage');
      return { Component: StoreDetailPage };
    },
    handle: defineHandle({
      roles: [...storesAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.stores',
    }),
  },
];
